import React from 'react';
import PageHelmet from '../Helper/PageHelmet';
import Footer from '../Helper/Footer';
import HeadSection from './HeadSection';
import ContentSection from './ContentSection';

const Features = () => {
    return (
        <>
            <PageHelmet pageTitle="Features" />
            <HeadSection />
            <ContentSection />
            <Footer />
        </>
    );
};

export default Features;